import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { respondToRange, StyledButton, StyledTable } from "@animech/ui";
import { ModalBase } from "../modal-base";
import {
	CustomScreenHeader,
	FooterButtons,
	ScreenContent,
} from "../modal-base.style";

export const CartModalBase = styled(ModalBase)`
	${ScreenContent} {
		padding: 0;

		${CustomScreenHeader} {
			display: none;
		}
		${FooterButtons} {
			display: flex;
			justify-content: center;
			margin-top: 0;
			margin-bottom: 8px;

			${StyledButton.Root} {
				padding: 16px 22px;

				${StyledButton.Label} {
					font-size: 20px;
				}
			}
		}
	}
`;

export const FooterNote = styled.div``;
export const TotalPrice = styled.p``;
export const PriceDisclaimer = styled.p``;
export const MobileHeader = styled.div``;
export const MobileTitle = styled.div``;

export const CartModalContent = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 1rem;
		overflow: hidden;

		${StyledTable.RootWrapper} {
			overflow: auto;
		}

		${StyledTable.HeaderCell} {
			color: ${theme.colors.foregrounds[5]} !important;
			font-weight: normal !important;
			text-transform: uppercase !important;
			font-size: ${theme.typography.fontSize.xSmall} !important;
		}

		${StyledTable.HeaderCell} {
			padding-right: ${theme.dimensions.margin.small} !important;
		}

		${StyledTable.DataCell} {
			font-size: ${theme.typography.fontSize.xSmall} !important;
		}

		${StyledTable.DataCell}, ${StyledTable.HeaderCell},${StyledTable.Row} {
			border-left: none !important;
			border-right: none !important;
			border-bottom: 1px solid #c1c1c1;
			border-top: 1px solid #c1c1c1;
		}

		${FooterNote} {
			color: ${theme.colors.foregrounds[5]};
		}

		${TotalPrice} {
			font-size: ${theme.typography.fontSize.xxxLarge};
			margin: ${theme.dimensions.margin.base} 0;
			text-align: right;
		}

		${PriceDisclaimer} {
			text-align: right;
			font-size: ${theme.typography.fontSize.xxLarge};
			font-weight: 300;
			color: #7e7e7e;
		}

		${MobileHeader} {
			display: flex;
			justify-content: space-between;
			padding: 24px;
			padding-top: 44px;

			${StyledButton.Root} {
				box-shadow: #dadada 0px 0px 6px 0px !important;
			}

			${MobileTitle} {
				display: flex;
				align-items: center;
				gap: 14px;
				font-size: 32px;
			}
		}

		${respondToRange(theme, "tablet", "down")} {
			padding: 0;

			${FooterNote} {
				margin-top: auto;
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 14px;
				padding: 34px 0;

				${TotalPrice},${PriceDisclaimer} {
					margin: 0;
				}

				${TotalPrice} {
					color: ${theme.colors.palette.black};
					font-size: 24px;
				}
			}
		}
	`}
`;
